export enum SpecialPrizesPresetsAPIRoutes {
    GET_SUBSIDIARIES = "subsidiary:query",
    GET_PRESETS = "config:settings:progressives:presets",
    GET_PRESET = "config:settings:progressives:presets:get",
    NEW_PRESET = "config:settings:progressives:presets:create",
    EDIT_PRESET = "config:settings:progressives:presets:edit",
    CERTIFIED_PRESET = "config:settings:progressives:presets:set:certified"
}
